// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (
gpsSubscriptionServiceCost) => (
{
  ...gpsSubscriptionServiceCost,
  cost: convertFromRubToKop(gpsSubscriptionServiceCost.cost)
});

const convertDataFromServer = (
gpsSubscriptionServiceCost) => (
{
  ...gpsSubscriptionServiceCost,
  cost: convertFromKopToRub(gpsSubscriptionServiceCost.cost)
});

const api = new CommonApi(
  'gpsSubscriptionServiceCost',
  'Общероссийский классификатор единиц измерения',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...api
};
